import React, { useMemo, useState } from "react";
import { compose } from "redux";
import { withStyles, withBreakpoint, withMobile } from "components/common";

import Table from "components/common/Table";
import TableFilter from "components/common/TableFilter";
import CustomHeader from "components/common/Table/CustomHeader";
import CustomTableHeader from "components/common/Table/CustomTableHeader";
import axios from "axios";
import { track } from "../../../utils/analytics";

const moment = require("moment-timezone");

const WaitingListTable = ({
  users = [],
  loading,
  handleNextPage,
  handlePreviousPage,
  handleSort,
  handleSearch,
  pageCount,
  pageIndex,
  initialSearchQuery,
  breakpointContext: { isBelow }
}) => {
  const [invitedIds, setInvitedIds] = useState([]);

  const triggerInvite = (email, e) => {
    console.log(`sending invite to ${email}`);
    track("DASHBOARD_ADMIN_TRIGGERED_INVITE", {
      userInvited: email
    });

    setInvitedIds([...invitedIds, email]);
    e.target.innerHTML = "invited!";
    const jwt = window.localStorage.getItem("jwt");
    axios
      .post(
        "/notifyWaitlistedUser",
        {
          to: email
        },
        {
          headers: { Authorization: `Bearer ${jwt}` }
        }
      )
      .then(response => {
        alert("invite successful");
      })
      .catch(error => {
        console.log(error);
        track("DASHBOARD_ADMIN_ERROR_INVITE_FAILED", {
          userInvited: email
        });
        alert("invite failed");
      });
    return false;
  };

  const buildTrigger = data => (
    <button
      disabled={invitedIds.includes(data.email)}
      onClick={e => {
        if (invitedIds.includes(data.email)) {
          e.preventDefault();
          window.alert("Already invited");
          return false;
        }
        triggerInvite(data.email, e);
      }}
    >
      Invite
    </button>
  );

  const computeColumns = belowMd =>
    belowMd
      ? [
          {
            Header: "Email",
            accessor: "email"
          },
          {
            Header: "Sign up date",
            accessor: "created_at",
            Cell: ({ value }) =>
              moment(value).tz("America/Los_Angeles")
                ? moment
                    .unix(value / 1000)
                    .tz("America/Los_Angeles")
                    .format("MMM D, YYYY, h:mma")
                : "N/A"
          },
          {
            Header: "status",
            accessor: data =>
              data.application.is_preapproved ? "Pre-Approved" : ""
          },
          {
            Header: "invite",
            accessor: data => buildTrigger(data)
          },
          {
            Header: "Waitlist Position",
            accessor: data =>
              (data.application && data.application.waitlist_position) || "N/A"
          }
        ]
      : [
          {
            Header: "Email",
            accessor: data =>
              data.email +
              (data.referrers && data.referrers.length
                ? `\n${data.referrers[0].sender_email}`
                : ""),
            Cell: ({ value }) => (
              <div className="flex-1 ml-1 md:ml-0">
                <div>{value.split("\n")[0]}</div>
                <div className="text-gray-500 text-sm md:text-sm">
                  {!!value.split("\n")[1] &&
                    `referred by: ${value.split("\n")[1]}`}
                </div>
              </div>
            )
          },
          {
            Header: "Sign up date",
            accessor: "created_at",
            Cell: ({ value }) =>
              moment(value).tz("America/Los_Angeles")
                ? moment
                    .unix(value / 1000)
                    .tz("America/Los_Angeles")
                    .format("MMM D, YYYY, h:mma")
                : "N/A"
          },
          {
            Header: "status",
            accessor: data =>
              data.application.is_preapproved ? "Pre-Approved" : ""
          },
          {
            Header: "invite",
            accessor: data => buildTrigger(data)
          },
          {
            Header: "Waitlist Position",
            accessor: data =>
              (data.application && data.application.waitlist_position) || "N/A"
          }
        ];

  const columns = useMemo(() => computeColumns(isBelow("md")), [
    computeColumns,
    isBelow
  ]);

  const container = elements => (
    <div className="mt-5">
      <h1 className="text-2xl font-title mb-2 font-light">Admin: Waitlist</h1>
      <div className="my-6">{elements}</div>
    </div>
  );

  if (loading) {
    return container(<div>Loading...</div>);
  }

  const itemsPerPage = 20;

  return container(
    users.length ? (
      <Table
        id="referrals-table"
        data={users}
        columns={columns}
        itemsPerPage={itemsPerPage}
        defaultSortOrder={{ idx: 1, order: true }}
        HeaderComponent={() => (
          <div className="flex">
            <CustomHeader
              nextPage={handleNextPage}
              previousPage={handlePreviousPage}
              canNextPage={pageIndex < pageCount - 1}
              canPreviousPage={pageIndex > 0}
              pageIndex={pageIndex}
              pageCount={pageCount}
              doSearch={handleSearch}
              initialSearchQuery={initialSearchQuery}
              showGotoPage={false}
              showSuperJump={false}
            />
          </div>
        )}
        TableHeaderComponent={CustomTableHeader({
          handleSort,
          orderBy: "wip",
          sortBy: "wip"
        })}
      />
    ) : (
      <div>Your Waiting List is currently empty!</div>
    )
  );
};

export default compose(
  withMobile,
  withStyles,
  withBreakpoint
)(WaitingListTable);
